// extracted by mini-css-extract-plugin
module.exports = {"also-read-wrapper":"ykszE","also-read-text":"MeaEn","also-read-link":"_1cNC1"};